// Import MUI icons
import {
  Cloud,
  Wifi,
  AttachMoney,
  Apartment,
  ShoppingCart,
  LocalHospital,
  LocalShipping,
  Chat,
  Settings,
  Security,
  Computer,
  Psychology,
} from "@mui/icons-material";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import PublishIcon from "@mui/icons-material/Publish";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ApiIcon from "@mui/icons-material/Api";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const services = [
  {
    title: "Comprehensive Web Development",
    description:
      "Create stunning, responsive websites tailored to your business needs. From basic to premium packages, we have the right solution for you.",
  },
  {
    title: "Reliable IT Support Services",
    description:
      "Keep your business running smoothly with our expert IT support services. We offer remote and onsite support to address all your technical issues.",
  },
  {
    title: "Effective Digital Marketing",
    description:
      "Boost your online presence with our digital marketing strategies. From SEO to social media management, we help you reach your target audience.",
  },
  {
    title: "Seamless E-commerce Solutions",
    description:
      "Set up and manage your online store with ease. Our e-commerce solutions include payment integration, product management, and ongoing support.",
  },
  {
    title: "Mobile Applications",
    description:
      "Develop high-quality mobile applications for both Android and iOS platforms. Our team ensures your app is user-friendly and feature-rich.",
  },
  {
    title: "Web Applications",
    description:
      "Build robust web applications that meet your business requirements. We specialize in creating scalable and secure web solutions.",
  },
  {
    title: "UI/UX Design",
    description:
      "Enhance user experience with our professional UI/UX design services. We create intuitive interfaces that engage and retain users.",
  },
  {
    title: "Workflow Automation",
    description:
      "Streamline your business operations with automated workflows that save time and boost efficiency. Our solutions are tailored to simplify processes and enhance productivity.",
  },
  {
    title: "Corporate System",
    description:
      "Implement efficient corporate systems to streamline your business operations. We offer customized solutions to meet your specific needs.",
  },
  {
    title: "Database Solutions",
    description:
      "Manage your data effectively with our database solutions. We provide database design, development, and maintenance services.",
  },
  {
    title: "Professional DevOps & Project Management",
    description:
      "Optimize your development process with our DevOps and project management services. We help you achieve faster delivery and improved quality.",
  },
  {
    title: "Customer Portal Software",
    description:
      "Enhance customer interaction with our custom portal software. We develop secure and user-friendly portals tailored to your business needs.",
  },
  {
    title: "Testing & QA",
    description:
      "Ensure the quality of your software with our testing and QA services. We provide comprehensive testing to identify and fix any issues.",
  },
];

const industries = [
  {
    name: "SaaS",
    icon: <Cloud sx={{ fontSize: 48 }} />,
  },
  {
    name: "IoT",
    icon: <Wifi sx={{ fontSize: 48 }} />,
  },
  {
    name: "FinTech",
    icon: <AttachMoney sx={{ fontSize: 48 }} />,
  },
  {
    name: "Real Estate",
    icon: <Apartment sx={{ fontSize: 48 }} />,
  },
  {
    name: "Retail",
    icon: <ShoppingCart sx={{ fontSize: 48 }} />,
  },
  {
    name: "HealthCare",
    icon: <LocalHospital sx={{ fontSize: 48 }} />,
  },
  {
    name: "Procurement",
    icon: <LocalShipping sx={{ fontSize: 48 }} />,
  },
  {
    name: "Communication",
    icon: <Chat sx={{ fontSize: 48 }} />,
  },
  {
    name: "General IT Support",
    icon: <Settings sx={{ fontSize: 48 }} />,
  },
  {
    name: "Security & Data Encryption",
    icon: <Security sx={{ fontSize: 48 }} />,
  },
  {
    name: "AI",
    icon: <Psychology sx={{ fontSize: 48 }} />,
  },
  {
    name: "Computer Hardware",
    icon: <Computer sx={{ fontSize: 48 }} />,
  },
];

const frontend = [
  { name: "HTML5", icon: "/HTML5.svg" },
  { name: "Angular", icon: "/Angular.svg" },
  { name: "CSS3", icon: "CSS3.svg" },
  { name: "Figma", icon: "Figma.svg" },
  { name: "Redux", icon: "Redux.svg" },
  { name: "JavaScript", icon: "JavaScript.svg" },
  { name: "TypeScript", icon: "TypeScript.svg" },
  { name: "React", icon: "React.svg" },
  { name: "jQuery", icon: "jQuery.svg" },
  { name: "Vue", icon: "Vue.js.svg" },
];

const backend = [
  { name: "Node.Js", icon: "/Node.js.svg" },
  { name: "Django", icon: "/Django.svg" },
  { name: "GraphQL", icon: "GraphQL.svg" },
  { name: "PHP", icon: "PHP.svg" },
  { name: "Python", icon: "Python.svg" },
];

const appDev = [
  { name: "Kotlin", icon: "/Kotlin.svg" },
  { name: "Object-C", icon: "/Objective-C.svg" },
  { name: "Swift", icon: "Swift.svg" },
  { name: "React", icon: "React.svg" },
];

const devOps = [
  { name: "Kubernetes", icon: "/Kubernetes.svg" },
  { name: "Nginx", icon: "/NGINX.svg" },
  { name: "Webflow", icon: "Webflow.svg" },
  { name: "AWS", icon: "/AWS.svg" },
];

const techLogo = [
  { name: "HTML5", icon: "/HTML5.svg" },
  { name: "Angular", icon: "/Angular.svg" },
  { name: "CSS3", icon: "CSS3.svg" },
  { name: "Figma", icon: "Figma.svg" },
  { name: "Redux", icon: "Redux.svg" },
  { name: "JavaScript", icon: "JavaScript.svg" },
  { name: "TypeScript", icon: "TypeScript.svg" },
  { name: "React", icon: "React.svg" },
  { name: "jQuery", icon: "jQuery.svg" },
  { name: "Vue", icon: "Vue.js.svg" },
  { name: "Node.Js", icon: "/Node.js.svg" },
  { name: "Django", icon: "/Django.svg" },
  { name: "GraphQL", icon: "GraphQL.svg" },
  { name: "PHP", icon: "PHP.svg" },
  { name: "Python", icon: "Python.svg" },
  { name: "Kotlin", icon: "/Kotlin.svg" },
  { name: "Object-C", icon: "/Objective-C.svg" },
  { name: "Swift", icon: "Swift.svg" },
  { name: "React", icon: "React.svg" },
  { name: "Kubernetes", icon: "/Kubernetes.svg" },
  { name: "Nginx", icon: "/NGINX.svg" },
  { name: "Webflow", icon: "Webflow.svg" },
  { name: "AWS", icon: "/AWS.svg" },
];

const start_ups = [
  {
    title: "Mobile Applications",
    decs: "We create high-quality mobile applications that provide seamless user experiences, tailored to meet your business needs and drive engagement on both Android and iOS platforms.",
  },
  {
    title: "Web Applications",
    decs: "Our team develops robust and scalable web applications using the latest technologies, ensuring responsive design and exceptional performance across all devices.",
  },
  {
    title: "UI/UX Design",
    decs: "We focus on creating intuitive and visually appealing user interfaces and experiences that enhance user satisfaction and drive user interaction.",
  },
  {
    title: "Embedded Software",
    decs: "Our expertise in embedded software development ensures reliable and efficient solutions for your hardware, meeting specific functional and performance requirements.",
  },
  {
    title: "Corporate System",
    decs: "We develop comprehensive corporate systems that streamline business processes, improve efficiency, and support your company's growth and operations.",
  },
  {
    title: "Database Solutions",
    decs: "Our database solutions are designed to manage, store, and retrieve data efficiently, ensuring data integrity, security, and accessibility for your business.",
  },
  {
    title: "Professional DevOps & Project Management",
    decs: "Our professional DevOps and project management services ensure seamless integration, continuous delivery, and efficient project execution, driving success for your development projects.",
  },
  {
    title: "Customer Portal Software",
    decs: "We develop secure and user-friendly customer portals that enhance communication, support, and engagement with your customers, providing them with a personalized experience.",
  },
  {
    title: "Testing & QA",
    decs: "Our thorough testing and quality assurance services ensure that your software is reliable, functional, and free of bugs, delivering a high-quality product to your users.",
  },
];

const MainServices = [
  {
    title: "Web Development",
    service: "Creating Stunning, Functional Websites",
    description:
      "Our web development team specializes in building dynamic, responsive, and user-friendly websites tailored to your business goals. Whether you need a simple informational site or a complex e-commerce platform, we have the skills and experience to deliver.",
    points: [
      "Custom Website Design: Unique designs that reflect your brand identity.",
      "Responsive Development: Ensuring your website looks great on all devices.",
      "E-commerce Solutions: Powerful and secure online stores to boost your sales.",
      "Content Management Systems (CMS): Easy-to-manage websites using WordPress, Joomla, and more.",
    ],
  },
  {
    title: "SaaS Development",
    service: "Building Scalable Software as a Service Solutions",
    description:
      "LinXar Labs offers top-tier SaaS development services, transforming your innovative ideas into robust, scalable software solutions. Our end-to-end SaaS development process ensures your software is ready to meet the demands of your business and customers.",
    points: [
      "Custom SaaS Applications: Tailored solutions that align with your business needs.",
      "API Integration: Seamless integration with third-party services.",
      "User Management Systems: Secure and efficient user management features.",
      "Maintenance and Support: Ongoing support to ensure your SaaS solution remains up-to-date and efficient.",
    ],
  },

  {
    title: "Digital Marketing",
    service: "Driving Traffic and Engagement with Expert Digital Marketing",
    description:
      "Our digital marketing services help you reach your target audience and achieve your business goals through effective online strategies. We use the latest tools and techniques to drive traffic, increase engagement, and boost conversions.",
    points: [
      "Search Engine Optimization (SEO): Improving your website's visibility on search engines.",
      "Social Media Management: Engaging with your audience on popular social platforms.",
      "Content Marketing: Creating valuable content that attracts and retains customers.",
      "Pay-Per-Click (PPC) Advertising: Targeted advertising campaigns to drive immediate traffic.",
    ],
  },
  {
    title: "Consulting and Strategy",
    service: "Expert Guidance to Navigate the Digital Landscape",
    description:
      "At LinXar Labs, we provide strategic consulting services to help you make informed decisions about your digital transformation. Our experts work closely with you to develop and implement strategies that align with your business objectives.",
    points: [
      "Digital Transformation Strategy: Planning and executing your digital journey.",
      "Business Process Optimization: Streamlining your operations for maximum efficiency.",
      "Technology Consulting: Advising on the best technologies for your business.",
      "Project Management: Ensuring your projects are delivered on time and within budget.",
    ],
  },
  {
    title: "DevOps",
    service: "Continuous Optimization Services",
    description:
      "Optimize your development and operations processes with our DevOps services. We help you achieve faster time-to-market, increased efficiency, and improved collaboration through automation and streamlined workflows.",
    points: [
      "Continuous Integration and Continuous Deployment (CI/CD)",
      "Infrastructure as Code (IaC)",
      "Automated Testing and Monitoring",
      "Containerization with Docker and Kubernetes",
      "Cloud Infrastructure Management (AWS, Azure, GCP)",
    ],
  },
  {
    title: "IT Support Services",
    service: "Reliable IT Support to Keep Your Business Running Smoothly",
    description:
      "Our IT support services are designed to provide you with peace of mind. From troubleshooting technical issues to implementing robust security measures, our team is here to ensure your IT infrastructure operates flawlessly.",
    points: [
      "Technical Support: Prompt resolution of IT issues.",
      "Network Management: Reliable and secure network solutions.",
      "Cybersecurity Services: Protecting your business from digital threats.",
      "Cloud Services: Efficient and secure cloud solutions for your business.",
    ],
  },
];

const industriesExpertiseCard = [
  {
    name: "SaaS",
    icon: <Cloud sx={{ fontSize: 48 }} />,
    description:
      "We specialize in developing scalable SaaS solutions that help businesses streamline operations, improve efficiency, and drive growth.",
  },
  {
    name: "IoT",
    icon: <Wifi sx={{ fontSize: 48 }} />,
    description:
      "Our IoT expertise allows us to create interconnected systems that enhance automation, data collection, and real-time decision-making.",
  },
  {
    name: "FinTech",
    icon: <AttachMoney sx={{ fontSize: 48 }} />,
    description:
      "We provide innovative FinTech solutions that enable secure and efficient financial transactions, data management, and compliance.",
  },
  {
    name: "Real Estate",
    icon: <Apartment sx={{ fontSize: 48 }} />,
    description:
      "Our real estate solutions help manage properties, streamline transactions, and enhance client interactions with cutting-edge technology.",
  },
  {
    name: "Retail",
    icon: <ShoppingCart sx={{ fontSize: 48 }} />,
    description:
      "We offer comprehensive retail solutions that improve customer experience, optimize inventory management, and boost sales.",
  },
  {
    name: "HealthCare",
    icon: <LocalHospital sx={{ fontSize: 48 }} />,
    description:
      "Our healthcare solutions are designed to improve patient care, streamline operations, and ensure data security and compliance.",
  },
  {
    name: "Procurement",
    icon: <LocalShipping sx={{ fontSize: 48 }} />,
    description:
      "We develop efficient procurement solutions that simplify supply chain management, reduce costs, and enhance vendor relations.",
  },
  {
    name: "Communication",
    icon: <Chat sx={{ fontSize: 48 }} />,
    description:
      "Our communication solutions enable seamless collaboration, enhance customer interactions, and support remote work environments.",
  },
  {
    name: "General IT Support",
    icon: <Settings sx={{ fontSize: 48 }} />,
    description:
      "We provide reliable IT support services to ensure your systems run smoothly, minimizing downtime and enhancing productivity.",
  },
  {
    name: "Security & Data Encryption",
    icon: <Security sx={{ fontSize: 48 }} />,
    description:
      "Our security solutions protect your data and systems with advanced encryption, threat detection, and proactive security measures.",
  },
  {
    name: "AI",
    icon: <Psychology sx={{ fontSize: 48 }} />,
    description:
      "We leverage AI technologies to create intelligent systems that enhance decision-making, automate processes, and drive innovation.",
  },
  {
    name: "Computer Hardware",
    icon: <Computer sx={{ fontSize: 48 }} />,
    description:
      "Our expertise in computer hardware ensures your infrastructure is robust, reliable, and optimized for performance.",
  },
];

const saasExpertise = [
  {
    name: "SaaS Application Development",
    icon: <CloudDownloadIcon sx={{ fontSize: 48 }} />,
    description:
      "We develop scalable and secure SaaS applications that meet your business needs and enhance operational efficiency.",
  },
  {
    name: "API Development",
    icon: <ApiIcon sx={{ fontSize: 48 }} />,
    description:
      "Our API development services ensure seamless integration and communication between your software applications.",
  },
  {
    name: "Testing and QA",
    icon: <CheckCircleIcon sx={{ fontSize: 48 }} />,
    description:
      "We provide thorough testing and quality assurance to ensure your SaaS applications are reliable and bug-free.",
  },
  {
    name: "Cloud Migration",
    icon: <PublishIcon sx={{ fontSize: 48 }} />,
    description:
      "Our cloud migration services help you move your applications and data to the cloud with minimal downtime and disruption.",
  },
  {
    name: "SaaS UX and UI Design",
    icon: <DesignServicesIcon sx={{ fontSize: 48 }} />,
    description:
      "We design intuitive and user-friendly interfaces that enhance user experience and drive customer satisfaction.",
  },
  {
    name: "SaaS Application Integration",
    icon: <IntegrationInstructionsIcon sx={{ fontSize: 48 }} />,
    description:
      "We ensure your SaaS applications integrate seamlessly with existing systems, enhancing functionality and performance.",
  },
];

const saasProcess = [
  {
    label: "Discovery Phase",
    description: `Understand the client's business needs, market requirements, and project goals.`,
    activities: [
      "Client Consultation: Engage with the client to understand their business model, target audience, and specific needs.",
      "Market Research: Conduct research to identify market trends, competition, and potential challenges.",
      "Feasibility Study: Assess the technical and economic feasibility of the project.",
      "Requirement Gathering: Document detailed requirements from stakeholders through interviews, questionnaires, and workshops.",
    ],
    deliverables: [
      "Project Vision Document",
      "Stakeholder Requirements",
      "Initial Project Scope",
    ],
  },
  {
    label: "Planning and Requirement Analysis",
    description:
      "Define the project scope, create a roadmap, and establish detailed requirements.",
    activities: [
      "Scope Definition: Clearly outline the project scope, including features and functionalities.",
      "Project Roadmap: Develop a high-level roadmap with milestones and timelines.",
      "Requirement Specification: Create detailed functional and non-functional requirements documents.",
      "Technology Stack Selection: Decide on the appropriate technologies, frameworks, and tools.",
      "Risk Management: Identify potential risks and create mitigation plans.",
    ],
    deliverables: [
      "Project Scope Document",
      "Detailed Requirements Specification",
      "Technology Stack Documentation",
      "Risk Management Plan",
    ],
  },
  {
    label: "Design and Prototyping",
    description: `Create visual representations of the application and design the system architecture.`,
    activities: [
      "User Interface (UI) Design: Design wireframes and mockups for the user interface.",
      "User Experience (UX) Design: Focus on creating an intuitive and seamless user experience.",
      "System Architecture Design: Develop the architecture for the SaaS application, including the database schema, APIs, and service integrations.",
      "Prototyping: Build interactive prototypes to validate the design and gather feedback from stakeholders.",
    ],
    deliverables: [
      "UI/UX Design Mockups",
      "Interactive Prototypes",
      "System Architecture Diagrams",
    ],
  },
  {
    label: "Development",
    description: `Transform the design into a functional SaaS application through coding and integration.`,
    activities: [
      "Front-end Development: Implement the user interface using chosen front-end technologies (e.g., HTML, CSS, JavaScript frameworks like React or Angular).",
      "Back-end Development: Develop the server-side logic, database management, and APIs using back-end technologies (e.g., Node.js, Python, Ruby on Rails).",
      "Integration: Integrate third-party services and APIs as required.",
      "Version Control: Use version control systems (e.g., Git) to manage code changes and collaboration.",
    ],
    deliverables: [
      "Source Code Repository",
      "Functional Modules and Features",
      "API Documentation",
    ],
  },
  {
    label: "Testing and Quality Assurance",
    description: `Ensure the application is stable, secure, and performs as expected`,
    activities: [
      "Unit Testing: Test individual components for functionality.",
      "Integration Testing: Verify that different modules and services work together seamlessly.",
      "System Testing: Conduct end-to-end testing to ensure the entire system functions correctly.",
      "Performance Testing: Assess the application's performance under various load conditions.",
      "Security Testing: Identify and fix vulnerabilities to protect against potential threats.",
      "User Acceptance Testing (UAT): Collaborate with end-users to validate the application against requirements.",
    ],
    deliverables: [
      "Test Plans and Cases",
      "Test Reports",
      "Bug and Issue Logs",
      "User Acceptance Test Sign-off",
    ],
  },
  {
    label: "Deployment",
    description: `Launch the SaaS application in a live environment.`,
    activities: [
      "Environment Setup: Configure production environments, including servers, databases, and network settings.",
      "Continuous Integration/Continuous Deployment (CI/CD): Implement CI/CD pipelines for automated testing and deployment.",
      "Data Migration: Transfer necessary data from existing systems to the new SaaS application.",
      "Deployment: Deploy the application to the production environment.",
      "Monitoring: Set up monitoring tools to track application performance and health.",
    ],
    deliverables: [
      "Deployed Application",
      "Deployment Scripts and Documentation",
      "Monitoring Dashboards",
    ],
  },
  {
    label: "Maintenance and Support",
    description: `Ensure the SaaS application remains functional, secure, and up-to-date.`,
    activities: [
      "Bug Fixes: Address any issues or bugs reported by users.",
      "Performance Optimization: Continuously improve application performance.",
      "Security Updates: Regularly apply security patches and updates.",
      "User Support: Provide customer support through various channels (e.g., email, chat, phone).",
    ],
    deliverables: [
      "Maintenance Logs",
      "Updated Documentation",
      "Customer Support Tickets",
    ],
  },
  {
    label: "Continuous Improvement",
    description: `Enhance the SaaS application based on user feedback and evolving business needs.`,
    activities: [
      "Feedback Collection: Gather feedback from users through surveys, interviews, and usage analytics.",
      "Feature Enhancements: Implement new features and improvements based on feedback.",
      "Product Updates: Regularly release updates with new features, improvements, and bug fixes.",
      "Market Analysis: Continuously monitor market trends and adjust the product roadmap accordingly.",
    ],
    deliverables: [
      "Product Roadmap Updates",
      "New Feature Releases",
      "User Feedback Reports",
    ],
  },
];

const technologies = [
  {
    category: "Front-End Development",
    items: [
      {
        name: "React",
        description:
          "A JavaScript library for building user interfaces, developed and maintained by Facebook.",
        features:
          "Component-based architecture, virtual DOM for efficient rendering, and a strong ecosystem.",
        logo: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
      },
      {
        name: "Angular",
        description:
          "A TypeScript-based open-source web application framework led by the Angular Team at Google.",
        features:
          "Two-way data binding, dependency injection, and comprehensive tooling.",
        logo: "https://angular.io/assets/images/logos/angular/angular.svg",
      },
      {
        name: "Vue.js",
        description:
          "A progressive JavaScript framework for building user interfaces, designed to be incrementally adoptable.",
        features:
          "Reactive data binding, component-based architecture, and simplicity.",
        logo: "https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg",
      },
    ],
  },
  {
    category: "Back-End Development",
    items: [
      {
        name: "Node.js",
        description:
          "An open-source, cross-platform, back-end JavaScript runtime environment that runs on the V8 engine and executes JavaScript code outside a web browser.",
        features:
          "Event-driven architecture, non-blocking I/O, and a rich ecosystem with npm.",
        logo: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Python (Django & Flask)",
        description:
          "Python is a versatile programming language, with Django being a high-level Python web framework that encourages rapid development and clean, pragmatic design. Flask is a micro web framework written in Python.",
        features:
          "Built-in admin interface, ORM, and scalability (Django). Lightweight, flexible, and modular (Flask).",
        logo: "https://www.python.org/static/community_logos/python-logo-master-v3-TM.png",
      },
      {
        name: "Ruby on Rails",
        description:
          "A server-side web application framework written in Ruby under the MIT License.",
        features:
          "Convention over configuration, a strong emphasis on testing, and an active community.",
        logo: "https://upload.wikimedia.org/wikipedia/commons/6/62/Ruby_On_Rails_Logo.svg",
      },
    ],
  },
  {
    category: "Database Management",
    items: [
      {
        name: "PostgreSQL",
        description:
          "A powerful, open-source object-relational database system with an emphasis on extensibility and standards compliance.",
        features:
          "ACID compliance, support for advanced data types, and strong performance.",
        logo: "https://upload.wikimedia.org/wikipedia/commons/2/29/Postgresql_elephant.svg",
      },
      {
        name: "MySQL",
        description: "An open-source relational database management system.",
        features:
          "Robust transactional support, strong data protection, and high availability.",
        logo: "https://www.mysql.com/common/logos/logo-mysql-170x115.png",
      },
      {
        name: "MongoDB",
        description:
          "A source-available cross-platform document-oriented database program classified as a NoSQL database.",
        features: "Flexible schema design, scalability, and high performance.",
        logo: "https://webassets.mongodb.com/_com_assets/cms/MongoDB_Logo_FullColorBlack_RGB-1312px-jotn6xzwxn.jpg",
      },
    ],
  },
  {
    category: "DevOps and Cloud Services",
    items: [
      {
        name: "Docker",
        description:
          "A set of platform-as-a-service products that use OS-level virtualization to deliver software in packages called containers.",
        features:
          "Containerization, portability, and microservices architecture support.",
        logo: "https://www.docker.com/wp-content/uploads/2022/03/vertical-logo-monochromatic.png",
      },
      {
        name: "Kubernetes",
        description:
          "An open-source container orchestration system for automating software deployment, scaling, and management.",
        features: "Automated container deployment, scaling, and management.",
        logo: "https://kubernetes.io/images/kubernetes-horizontal-color.png",
      },
      {
        name: "AWS (Amazon Web Services)",
        description:
          "A comprehensive and widely adopted cloud platform, offering over 200 fully featured services from data centers globally.",
        features:
          "Scalability, a broad set of cloud services, and global reach.",
        logo: "https://a0.awsstatic.com/libra-css/images/logos/aws_logo_smile_1200x630.png",
      },
    ],
  },
  {
    category: "Mobile Development",
    items: [
      {
        name: "React Native",
        description:
          "An open-source mobile application framework created by Facebook, used to develop applications for Android, iOS, and UWP by enabling developers to use React along with native platform capabilities.",
        features:
          "Single codebase for multiple platforms, fast development cycles, and a strong community.",
        logo: "https://reactnative.dev/img/header_logo.svg",
      },
      {
        name: "Flutter",
        description:
          "An open-source UI software development kit created by Google, used to develop cross platform applications from a single codebase.",
        features:
          "High performance, expressive and flexible UI, and a rich set of pre-designed widgets.",
        logo: "https://storage.googleapis.com/cms-storage-bucket/0dbfcc7a59cd1cf16282.png",
      },
      {
        name: "Swift",
        description:
          "A powerful and intuitive programming language for macOS, iOS, watchOS, and tvOS.",
        features:
          "Fast, modern, safe by design, and interactive development experience.",
        logo: "https://developer.apple.com/swift/images/swift-og.png",
      },
    ],
  },
];

const startUpServices = [
  {
    titles: "Idea Validation and Market Research",
    contents: [
      "Concept Evaluation: Assess the feasibility and potential of your startup idea.",
      "Market Analysis: Conduct thorough research to understand market needs, competition, and opportunities.",
      "User Research: Identify target audiences and gather insights to inform product development.",
    ],
  },
  {
    titles: "Product Development",
    contents: [
      "MVP Development: Build a Minimum Viable Product (MVP) to test your idea in the market quickly and cost-effectively.",
      "Custom Software Development: Create bespoke software solutions tailored to your specific business needs.",
      "User-Centric Design: Develop intuitive and engaging user interfaces and experiences.",
    ],
  },
  {
    titles: "Technology Consulting",
    contents: [
      "Technical Strategy: Define a robust technical strategy that aligns with your business goals.",
      "Technology Stack Selection: Choose the right technologies and frameworks to ensure scalability and performance.",
      "DevOps and Cloud Solutions: Implement DevOps practices and cloud services to enhance efficiency and reliability.",
    ],
  },
  {
    titles: "Growth and Scaling",
    contents: [
      "Scalable Architecture: Design systems and applications that grow with your business.",
      "Performance Optimization: Improve the performance and speed of your applications.",
      "Data Analytics: Leverage data to make informed decisions and drive growth.",
    ],
  },
  {
    titles: "Funding and Mentorship",
    contents: [
      "Investor Relations: Connect with investors and prepare for funding rounds.",
      "Pitch Deck Development: Craft compelling pitch decks to attract investors.",
      "Mentorship: Gain insights and advice from experienced industry professionals.",
    ],
  },
];

const startUpProcesses = [
  {
    label: "Discovery Phase",
    deliverables: [
      "Initial consultation to understand your vision and goals.",
      "Detailed requirements gathering and project scoping.",
    ],
  },
  {
    label: "Planning and Strategy",
    deliverables: [
      "Develop a comprehensive project plan and roadmap.",
      "Define milestones, timelines, and key performance indicators (KPIs).",
    ],
  },
  {
    label: "Development and Testing",
    deliverables: [
      "Agile development process with regular updates and iterations.",
      "Rigorous testing to ensure quality and functionality.",
    ],
  },
  {
    label: "Launch and Beyond",
    deliverables: [
      "Support for launching your product to the market.",
      "Ongoing maintenance and support to ensure long-term success.",
    ],
  },
];

export {
  industries,
  frontend,
  backend,
  devOps,
  appDev,
  start_ups,
  industriesExpertiseCard,
  saasExpertise,
  services,
  saasProcess,
  technologies,
  techLogo,
  startUpServices,
  startUpProcesses,
  MainServices,
};
